import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';
import SeccionPageHeader from './../../Utils/SeccionPageHeader';
import CargandoSpinner from './../../Utils/CargandoSpinner';

export default function DiagVidaLibertad(){
    const {token} = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosVidaLibertad, setDatosVidaLibertad] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatovidalibertad?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosVidaLibertad(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.idpersona}`);
    };
    function verAtencionPersona (row){
                return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.idpersona} row={row} />
            }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionPersona(row),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: 'Algún miembro del Hogar sea dirigente o no de población desplazada presenta algún riesgo extraordinario o extremo que este poniendo en peligro su vida?', selector: row => row.tip_riesgo, sortable: true, width: '15%'},
        { name: 'El hecho ha sido puesto en conocimiento o denunciado ante las autoridades?', selector: row => row.vid_conociautoridades, sortable: true, width: '20%' },
        { name: 'Por qué no se ha colocado la denuncia?', selector: row => row.tip_tiponodenuncia, sortable: true, width: '10%' },
        { name: '¿Esta está siendo beneficiado con alguna medida de protección?', selector: row => row.vid_beneficioproteccion, sortable: true, width: '10%' },
        { name: 'Cuál es la medida de protección?', selector: row => row.tip_tipobenproteccion, sortable: true, width: '10%' },
        { name: 'Algún miembro del Hogar después del desplazamiento ha sido afectado por', selector: row => row.tip_tipoafectacion, sortable: true, width: '10%' },
        { name: '¿El hecho ha sido puesto en conocimiento de las autoridades?', selector: row => row.tip_tipoconoaut, sortable: true, width: '10%' }
    ];
    
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatovidalibertad?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_vida_libertad.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Diagnostico vida y libertad"
                idCabezaFamilia="0"
                url=""
                nombreurl="Diagnosticos"
                nombreform="Vida y libertad"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosVidaLibertad} titulo={'Informe Datos Vida y Libertad'} exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Vida y libertad"
                                    columns={columns}
                                    data={datosVidaLibertad}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}